import classNames from "classnames";
import { type FC, type ReactNode } from "react";
import LinearInfo from "~/features/configurator/Linear/components/LinearInfo";

export interface LabeledInputProps {
  children?: ReactNode;
  label: ReactNode;
  className?: string;
  hasError?: boolean;
  cutOverflow?: boolean;
  info?: string;
}

const LabeledInput: FC<LabeledInputProps> = (props) => {
  return (
    <div className={classNames(props.className, "scha__order-box__input")}>
      <span
        className={classNames("scha__order-box__input__label", {
          "scha__order-box__input__label--error": props.hasError,
          scha__header__welcome__name: props.cutOverflow,
        })}
        title={typeof props.label === "string" ? props.label : undefined}
      >
        <div className={"d-flex flex-align-center"}>
          {props.label}
          {props.info && <LinearInfo info={props.info} popupClassName={"scha__lc__external-content--shaft"} />}
        </div>
      </span>
      {props.children}
    </div>
  );
};

export default LabeledInput;
